import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/demographics")({
  component: lazyRouteComponent(() => import("./-pages/admin.demographics")),
  head: () => ({
    meta: [
      { title: "الديموغرافيا · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
